import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { CoreCommonModule } from '@xbaht/ui/core/common.module';
import { CoreSidebarsModule } from '@xbaht/ui/core/components/core-sidebars/core-sidebars.module';

import { NavbarsModule } from '../components/navbars/navbars.module';
import { ContentsModule } from '../components/contents/contents.module';
import { MenusModule } from '../components/menus/menus.module';
import { FootersModule } from '../components/footers/footers.module';

import { VerticalLayoutComponent } from './vertical/vertical-layout.component';

@NgModule({
  declarations: [VerticalLayoutComponent],
  imports: [
    CommonModule,
    RouterModule,
    CoreCommonModule,
    CoreSidebarsModule,
    NavbarsModule,
    MenusModule,
    ContentsModule,
    FootersModule,
  ],
  exports: [VerticalLayoutComponent],
})
export class VerticalLayoutModule {}
